import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { schedaCoopSocialiBaseRules } from './scheda-coop-sociali-base.rules';
import { schedaCoopSocialiCategoriaRules } from './scheda-coop-sociali-categoria.rules';

export const SchedaCoopSocialiRules: FormGroupRules = {
    ...schedaCoopSocialiBaseRules,
    ...schedaCoopSocialiCategoriaRules,
};

export const SchedaCoopSocialiFormValidators = [...Object.values(SchedaCoopSocialiRules)];
